import * as React from "react";

interface GenModalProps {
  open: boolean;
  children: React.ReactNode;
}

export default function GenModal(
  {
    open,
    children,
  }: GenModalProps,
) {
  if (open) {
    return (
      <div className="gen-modal">
        {children}
      </div>
    );
  } else {
    return(null);
  }
}
